<template>
  <el-row class="userheder">
    <div>
      <el-form
        :inline="true"
        :model="formSearch"
        ref="formSearch"
        class="demo-form-inline"
      >
        <div style="display: flex">
          <el-form-item label="日期">
            <el-date-picker
              v-model="formSearch.formdate"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              style="width: 320px"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="产品">
            <product-select
              :value.sync="formSearch.afid"
              placeholder="请选择产品"
              :isDefault="true"
              @change="handerAfid"
              popper-class="BI-select BI-select-product"
            >
            </product-select>
          </el-form-item>
          <el-form-item label="渠道">
            <el-select
              v-model="formSearch.media"
              placeholder="全部"
              multiple
              collapse-tags
              @change="changeSelect"
              class="multipleselect"
              ref="chnlref"
              popper-class="app-select-self"
            >
              <div class="input-search">
                <el-input
                  v-model="text"
                  size="mini"
                  suffix-icon="el-icon-search"
                />
              </div>
              <el-checkbox
                v-model="checked"
                @change="selectAll($event, 'check')"
                >全选</el-checkbox
              >
              <div @click="clickclear" class="clearbutton">
                <span style="font-size: 14px">清空</span>
              </div>

              <el-option
                v-for="item in mediaList.filter(
                  (i) => !text || i.toLowerCase().includes(text.toLowerCase())
                )"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="地区">
            <areaMultiSelect
              :value.sync="formSearch.geo"
              :optionsList="countryList"
            >
            </areaMultiSelect>
          </el-form-item>
          <el-form-item label="域名组">
            <el-select
              v-model="formSearch.accountGroupCodes"
              placeholder="请选择域名组"
              clearable
              style="width: 200px"
              size="medium"
            >
              <el-option
                v-for="item in accountGroupCodeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="flex: 1; text-align: end">
            <el-button type="primary" @click="onSubmit('formSearch')"
              >查询</el-button
            >
            <el-button type="primary" @click="handlerReset">重置</el-button>
            <el-button
              type="success"
              style="height: 32px; border-radius: 2px; padding: 0px 9px"
              @click="handleEnterData"
            >
              录入数据
            </el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="headerleft">
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <i class="el-icon-refresh" @click="onSubmit('formSearch')" />
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="dark"
        content="下载excel"
        placement="top"
      >
        <i class="el-icon-download" @click="downloadFile" />
      </el-tooltip>
    </div>
  </el-row>
</template>
<script>
import { clearallshortcutclass } from "@/utils/tool";
import areaMultiSelect from "@/components/areaMultiSelect.vue";
import moment from "moment";
// import Axios from "axios";
export default {
  components: {
    areaMultiSelect,
  },
  computed: {
    mediaList: function () {
      return this.$store.state.Summary.mediaList;
    },
  },
  mounted: function () {
    const timer = setInterval(() => {
      if (this.formSearch.afid) {
        clearInterval(timer);
        this.$store.dispatch("getCountryListAndMedia", {
          afid: this.formSearch.afid,
          cb: (result) => {
            this.countryList = result.countryList;
            let param = {
              pageSize: 500,
              pageNumber: 1,
              dateStart: moment(this.formSearch.formdate[0]).format("YYYYMMDD"),
              dateEnd: moment(this.formSearch.formdate[1]).format("YYYYMMDD"),
              afid: this.formSearch.afid,
              geo: this.formSearch.geo.join(","),
              accountGroupCodes: this.formSearch.accountGroupCodes
                ? [this.formSearch.accountGroupCodes]
                : undefined,
              media: this.formSearch.media.length
                ? this.formSearch.media.join()
                : null,
            };
            // getalldimensiondataFetch({ data: JSON.stringify(param) }).then(
            //   (res) => {
            //     console.log(res);
            //     this.$emit("showLoading", false);
            //     this.$emit("refreshTable");
            //   }
            // );
            this.$emit("refreshTable", param);
            // this.$store.dispatch("getSummaryList", {
            //   param,
            //   cb: () => {
            //     this.$emit("showLoading", false);
            //     this.$emit("refreshTable");
            //   },
            // });
          },
        });
      }
    }, 200);
  },
  data() {
    return {
      countryList: [],
      checked: false,
      text: "",
      accountGroupCodeList: JSON.parse(
        localStorage.getItem("accountGroupCodeList") || "[]"
      ),
      formSearch: {
        formdate: [
          new Date(new Date().getTime() - 3600 * 1000 * 24 * 16),
          new Date(new Date().getTime() - 3600 * 1000 * 24 * 9),
        ],
        afid: null,
        geo: [],
        accountGroupCodes: null,
        media: [],
      },
      pickerOptions: {
        onPick: function ({ maxDate, minDate }) {
          clearallshortcutclass(this.$el);
          console.log(maxDate, minDate);
        },
        disabledDate: function (date) {
          if (
            new Date().getTime() - date.getTime() - 9 * 24 * 3600 * 1000 >
            0
          ) {
            return false;
          }
          return true;
        },
        // disabledDate: function(time) {
        //   return time.getTime() > Date.now();
        // }
      },
      value1: "",
      value2: "",
    };
  },
  methods: {
    clickclear() {
      // this.$refs.chnlref.value = [];
      this.formSearch.media = [];
    },
    handlerReset() {
      this.formSearch = {
        formdate: [
          new Date(new Date().getTime() - 3600 * 1000 * 24 * 16),
          new Date(new Date().getTime() - 3600 * 1000 * 24 * 9),
        ],
        afid: null,
        geo: [],
        accountGroupCodes: null,
        media: [],
      };
      this.onSubmit("formSearch");
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {
            dateStart: moment(this.formSearch.formdate[0]).format("YYYYMMDD"),
            dateEnd: moment(this.formSearch.formdate[1]).format("YYYYMMDD"),
            afid: this.formSearch.afid,
            geo: this.formSearch.geo.join(","),
            media: this.formSearch.media.length
              ? this.formSearch.media.join()
              : null,
            accountGroupCodes: this.formSearch.accountGroupCodes
              ? [this.formSearch.accountGroupCodes]
              : undefined,
          };
          this.$emit("refreshTable", param);
        } else {
          return false;
        }
      });
    },
    handleEnterData() {
      this.$emit("handleEnterData");
    },
    downloadFile() {
      this.$emit("downloadFile");
    },
    setFilterParams(params) {
      this.formSearch = params;
    },
    changeSelect(value) {
      if (
        this.checked &&
        this.formSearch.media.length <
          this.$store.state.Summary.mediaList.length
      ) {
        this.checked = false;
        this.formSearch.media = value;
      }
    },
    selectAll(event, value) {
      if (event) {
        this.formSearch.media = this.$store.state.Summary.mediaList;
      } else {
        value == "check" ? (this.formSearch.media = []) : null;
      }
    },
    handerAfid(e) {
      this.formSearch.geo = [];
      this.$store.dispatch("getCountryList", {
        afid: e,
        cb: (result) => {
          this.countryList = result;
        },
      });
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@borderline: #e6e6e6;
.el-date-editor--daterange {
  width: 483px;
}
.el-button {
  margin-left: 14px;
}
.userheder {
  padding: 10px;
  margin: 2px;
  border-radius: 3px;
  align-items: baseline;
}
.headerleft {
  text-align: right;
  i {
    font-size: 20px;
    margin-right: 10px;
    cursor: pointer;
  }
  i:hover {
    color: #409eff;
  }
}
.el-checkbox {
  width: 95%;
  text-align: right;
}
.input-search {
  width: 90%;
  margin-left: 5%;
}
.clearbutton {
  display: flex;
  padding: 0 20px;
  height: 34px;
  line-height: 34px;
  box-sizing: border-box;

  &:hover {
    background: #f5f7fa;
    cursor: pointer;
  }
}
</style>
